import { render, staticRenderFns } from "./DataPlotPopup.vue?vue&type=template&id=42041bb0&scoped=true"
import script from "./DataPlotPopup.vue?vue&type=script&lang=js"
export * from "./DataPlotPopup.vue?vue&type=script&lang=js"
import style0 from "./DataPlotPopup.vue?vue&type=style&index=0&id=42041bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42041bb0",
  null
  
)

export default component.exports